import LegalPage from "../../components/LegalPage";

export default function RefundPolicy() {
  return (
    <LegalPage
      badge="Legal"
      title="Refund Policy"
      lastUpdated="Feb 1, 2026"
      sections={[
        {
          heading: "Our Commitment",
          paragraphs: [
            "We want every Brivo customer to be delighted with their experience. If something isn't working as expected, our first priority is to make it right — but we also offer a clear, fair refund policy.",
          ],
        },
        {
          heading: "14-Day Free Trial",
          paragraphs: ["All new paid subscriptions include a 14-day free trial. No credit card is required to begin the trial. You can cancel any time during the trial without being charged."],
        },
        {
          heading: "Monthly Subscriptions",
          paragraphs: ["Monthly subscriptions are non-refundable once a billing period begins. However, you may cancel at any time, and your subscription will remain active through the end of the current billing period without further charges."],
        },
        {
          heading: "Annual Subscriptions",
          paragraphs: ["Annual subscriptions are eligible for a pro-rated refund within the first 30 days of the term. After 30 days, annual fees are non-refundable, but you may cancel to prevent automatic renewal."],
        },
        {
          heading: "Eligibility for Refund",
          paragraphs: ["You may be eligible for a refund if:"],
          bullets: [
            "You experience a documented service outage longer than 24 consecutive hours within a billing period.",
            "You were billed in error (e.g., duplicate charges).",
            "You request a refund within 30 days of the initial annual subscription charge.",
          ],
        },
        {
          heading: "How to Request a Refund",
          paragraphs: ["Email refunds@brivo.app with your account email, subscription details, and reason for the request. Our team will respond within 2 business days. Approved refunds are processed within 5-10 business days back to your original payment method."],
        },
        {
          heading: "Non-Refundable Items",
          paragraphs: ["Add-on services, custom integrations, professional implementation services, and third-party transaction fees are non-refundable."],
        },
        {
          heading: "Chargebacks",
          paragraphs: ["If you initiate a chargeback rather than contacting us first, your account may be suspended pending resolution. We strongly encourage you to email us before disputing a charge — most issues are resolved in under an hour."],
        },
      ]}
    />
  );
}
